import React from 'react';

import { useRef } from 'react';

import IconClientArea from '../components/Icons/menu/IconClientArea';
// import IconFunction from '../components/Icons/menu/IconFunction';
import IconProduct from '../components/Icons/menu/IconProduct';
// import IconQandA from '../components/Icons/menu/IconQandA';
// import Function from '../pages/Home/Function';
import IGamingOffer from '../pages/Home/IGamingOffer';
// import IGamingServices from '../pages/Home/IGamingServices';
import Introduction from '../pages/Home/Introduction';
// import LatestNews from '../pages/Home/LatestNews';
import IGamingSolution from '../pages/Home/IGamingSolution';
import JadeSoftInterface from '../pages/Home/JadeSoftInterface';
import JadeSoftTeam from '../pages/Home/JadeSoftTeam';
import Portfolio from '../pages/Home/Portfolio';
import PremiumService from '../pages/Home/PremiumService';
import Security from '../pages/Home/Security';
import Subscriptions from '../pages/Home/Subscription';
import WhoIsJadeSoft from '../pages/Home/WhoIsJadeSoft';

import GamingApi from '../pages/GameApi/GamingApi';

import SelfService from '../pages/SelfServiceSolution/SelfService';
import JadeSoftMarket from '../pages/Solution/JadeSoftMarket';
import TurnKeySolution from '../pages/Solution/TurnKeySolution';

import WhiteLabelSolution from '../pages/WhiteLabel/WhiteLabelSolution';
import IGamingWhiteLabel from '../pages/WhiteLabel/iGamingWhiteLabel';

import OurPartners from '../pages/About/OurPartners';
import Telegram from '../pages/Home/Telegram';

import ProvidersSection from '../components/Shared/ProvidersSection';


import { useTheme } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import Divider from '../pages/Home/Divider';

export default function useSection() {
  const introRef = useRef(null);
  const serviceRef = useRef(null);
  const functionRef = useRef(null);
  const qaRef = useRef(null);
  const inquiryRef = useRef(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const sections = [
    {
      id: 'introduction-page',
      label: 'introduction',
      path: '/introductions',
      Icon: IconProduct,
      isMenu: true,
      animation: {
        initial: { rotate: '0deg', scale: 1 },
        hover: { rotate: '180deg', transition: { duration: 1, type: 'spring' }, scale: 1.1 },
      },
      ref: introRef,
      children: <>
        {/* <Wave
        paused={false}
        style={{ display: 'flex' }}
        options={{
          height: 20,
          amplitude: 20,
          speed: 0.15,
          points: 3,
        }}
      /> */}
        <Introduction />
      </>,
    },
    {
      id: 'introduction-page',
      label: 'introduction',
      path: '/jadesoft',
      Icon: IconProduct,
      isMenu: false,
      animation: {
        initial: { rotate: '0deg', scale: 1 },
        hover: { rotate: '180deg', transition: { duration: 1, type: 'spring' }, scale: 1.1 },
      },
      ref: introRef,
      children: <WhoIsJadeSoft />,
    },
    {
      id: 'introduction-page',
      label: 'introduction',
      path: '/igamingoffer',
      Icon: IconProduct,
      isMenu: false,
      animation: {
        initial: { rotate: '0deg', scale: 1 },
        hover: { rotate: '180deg', transition: { duration: 1, type: 'spring' }, scale: 1.1 },
      },
      ref: introRef,
      children: <IGamingOffer />,
    },
    {
      id: 'introduction-page',
      label: 'introduction',
      path: '/igamingsolution',
      Icon: IconProduct,
      isMenu: false,
      animation: {
        initial: { rotate: '0deg', scale: 1 },
        hover: { rotate: '180deg', transition: { duration: 1, type: 'spring' }, scale: 1.1 },
      },
      ref: introRef,
      children: <IGamingSolution />,
    },
    {
      id: 'introduction-page',
      label: 'introduction',
      path: '/jadesof-tteam',
      Icon: IconProduct,
      isMenu: false,
      animation: {
        initial: { rotate: '0deg', scale: 1 },
        hover: { rotate: '180deg', transition: { duration: 1, type: 'spring' }, scale: 1.1 },
      },
      ref: introRef,
      children: <JadeSoftTeam />,
    },
    {
      id: 'introduction-page',
      label: 'introduction',
      path: '/security',
      Icon: IconProduct,
      isMenu: false,
      animation: {
        initial: { rotate: '0deg', scale: 1 },
        hover: { rotate: '180deg', transition: { duration: 1, type: 'spring' }, scale: 1.1 },
      },
      ref: introRef,
      children: <Security />,
    },
    {
      id: 'introduction-page',
      label: 'introduction',
      path: '/interface',
      Icon: IconProduct,
      isMenu: false,
      animation: {
        initial: { rotate: '0deg', scale: 1 },
        hover: { rotate: '180deg', transition: { duration: 1, type: 'spring' }, scale: 1.1 },
      },
      ref: introRef,
      children: <>
        {/* <Wave
        fill="#ffffff"
        paused={false}
        style={{ display: 'flex', position: 'absolute', marginTop: '-46px', zIndex: 999 }}
        options={{
          height: 20,
          amplitude: 20,
          speed: 0.15,
          points: 3,
        }}
      /> */}
        <JadeSoftInterface />
      </>,
    },
    {
      id: 'introduction-page',
      label: 'introduction',
      path: '/interface',
      Icon: IconProduct,
      isMenu: false,
      animation: {
        initial: { rotate: '0deg', scale: 1 },
        hover: { rotate: '180deg', transition: { duration: 1, type: 'spring' }, scale: 1.1 },
      },
      ref: introRef,
      children: <PremiumService />,
    },
    {
      id: 'introduction-page',
      label: 'introduction',
      path: '/portfolio',
      Icon: IconProduct,
      isMenu: false,
      animation: {
        initial: { rotate: '0deg', scale: 1 },
        hover: { rotate: '180deg', transition: { duration: 1, type: 'spring' }, scale: 1.1 },
      },
      ref: introRef,
      children: <Portfolio />,
    },
    {
      id: 'inquiry-page',
      label: 'inquiry',
      path: '/inquiry',
      Icon: IconClientArea,
      isMenu: true,
      animation: {
        initial: { rotate: '0deg', scale: 1 },
        hover: { rotate: '180deg', transition: { duration: 1, type: 'spring' }, scale: 1.1 },
      },
      ref: inquiryRef,
      children: <Telegram />,
    },
  ];


  const sectionGameApi = [
    {
      id: 'introduction-page',
      label: 'introduction',
      path: '/game-apis',
      Icon: IconProduct,
      isMenu: false,
      animation: {
        initial: { rotate: '0deg', scale: 1 },
        hover: { rotate: '180deg', transition: { duration: 1, type: 'spring' }, scale: 1.1 },
      },
      ref: introRef,
      children: <GamingApi />,
    },
    {
      id: 'introduction-page',
      label: 'introduction',
      path: '/interface',
      Icon: IconProduct,
      isMenu: false,
      animation: {
        initial: { rotate: '0deg', scale: 1 },
        hover: { rotate: '180deg', transition: { duration: 1, type: 'spring' }, scale: 1.1 },
      },
      ref: introRef,
      children: <Divider height={!isMobile ? 1400 : 2000} minus={!isMobile ? 1700 : 2200} />,
    },
    {
      id: 'game-provider',
      label: 'game provider',
      path: '/game-apis',
      Icon: IconProduct,
      isMenu: false,
      animation: {
        initial: { rotate: '0deg', scale: 1 },
        hover: { rotate: '180deg', transition: { duration: 1, type: 'spring' }, scale: 1.1 },
      },
      ref: introRef,
      children: <ProvidersSection padding={'2% 5%'} backgroundColor={'#fff'} />,
    },

  ];

  const sectionSolution = [
    {
      id: 'introduction-page',
      label: 'introduction',
      path: '/solutions',
      Icon: IconProduct,
      isMenu: false,
      animation: {
        initial: { rotate: '0deg', scale: 1 },
        hover: { rotate: '180deg', transition: { duration: 1, type: 'spring' }, scale: 1.1 },
      },
      ref: introRef,
      children: <TurnKeySolution />,
    },
    {
      id: 'introduction-page',
      label: 'introduction',
      path: '/solutions',
      Icon: IconProduct,
      isMenu: false,
      animation: {
        initial: { rotate: '0deg', scale: 1 },
        hover: { rotate: '180deg', transition: { duration: 1, type: 'spring' }, scale: 1.1 },
      },
      ref: introRef,
      children: <Security />,
    },
    {
      id: 'introduction-page',
      label: 'introduction',
      path: '/solutions',
      Icon: IconProduct,
      isMenu: false,
      animation: {
        initial: { rotate: '0deg', scale: 1 },
        hover: { rotate: '180deg', transition: { duration: 1, type: 'spring' }, scale: 1.1 },
      },
      ref: introRef,
      children: <JadeSoftMarket />,
    },
    {
      id: 'introduction-page',
      label: 'introduction',
      path: '/solutions',
      Icon: IconProduct,
      isMenu: false,
      animation: {
        initial: { rotate: '0deg', scale: 1 },
        hover: { rotate: '180deg', transition: { duration: 1, type: 'spring' }, scale: 1.1 },
      },
      ref: introRef,
      children: <PremiumService />,
    },
    {
      id: 'introduction-page',
      label: 'introduction',
      path: '/portfolio',
      Icon: IconProduct,
      isMenu: false,
      animation: {
        initial: { rotate: '0deg', scale: 1 },
        hover: { rotate: '180deg', transition: { duration: 1, type: 'spring' }, scale: 1.1 },
      },
      ref: introRef,
      children: <Portfolio />,
    },
    {
      id: 'introduction-page',
      label: 'introduction',
      path: '/interface',
      Icon: IconProduct,
      isMenu: false,
      animation: {
        initial: { rotate: '0deg', scale: 1 },
        hover: { rotate: '180deg', transition: { duration: 1, type: 'spring' }, scale: 1.1 },
      },
      ref: introRef,
      children: <Divider height={!isMobile ? 6100 : 7800} minus={!isMobile ? 6400 : 8000} />,
    },
    {
      id: 'game-provider',
      label: 'game provider',
      path: '/game-apis',
      Icon: IconProduct,
      isMenu: false,
      animation: {
        initial: { rotate: '0deg', scale: 1 },
        hover: { rotate: '180deg', transition: { duration: 1, type: 'spring' }, scale: 1.1 },
      },
      ref: introRef,
      children: <ProvidersSection padding={'2% 5%'} backgroundColor={'#fff'} />,
    },

  ];

  const sectionSelfService = [
    {
      id: 'introduction-page',
      label: 'introduction',
      path: '/self-service',
      Icon: IconProduct,
      isMenu: false,
      animation: {
        initial: { rotate: '0deg', scale: 1 },
        hover: { rotate: '180deg', transition: { duration: 1, type: 'spring' }, scale: 1.1 },
      },
      ref: introRef,
      children: <SelfService />,
    },

  ];

  const sectionWhitelabel = [
    {
      id: 'white-label',
      label: 'white label',
      path: '/white-label',
      Icon: IconProduct,
      isMenu: false,
      animation: {
        initial: { rotate: '0deg', scale: 1 },
        hover: { rotate: '180deg', transition: { duration: 1, type: 'spring' }, scale: 1.1 },
      },
      ref: introRef,
      children: <WhiteLabelSolution />,
    },
    {
      id: 'introduction-page',
      label: 'introduction',
      path: '/solutions',
      Icon: IconProduct,
      isMenu: false,
      animation: {
        initial: { rotate: '0deg', scale: 1 },
        hover: { rotate: '180deg', transition: { duration: 1, type: 'spring' }, scale: 1.1 },
      },
      ref: introRef,
      children: <JadeSoftMarket />,
    },
    {
      id: 'introduction-page',
      label: 'introduction',
      path: '/interface',
      Icon: IconProduct,
      isMenu: false,
      animation: {
        initial: { rotate: '0deg', scale: 1 },
        hover: { rotate: '180deg', transition: { duration: 1, type: 'spring' }, scale: 1.1 },
      },
      ref: introRef,
      children: <IGamingWhiteLabel />,
    },
    {
      id: 'introduction-page',
      label: 'introduction',
      path: '/solutions',
      Icon: IconProduct,
      isMenu: false,
      animation: {
        initial: { rotate: '0deg', scale: 1 },
        hover: { rotate: '180deg', transition: { duration: 1, type: 'spring' }, scale: 1.1 },
      },
      ref: introRef,
      children: <Security />,
    },
    {
      id: 'introduction-page',
      label: 'introduction',
      path: '/interface',
      Icon: IconProduct,
      isMenu: false,
      animation: {
        initial: { rotate: '0deg', scale: 1 },
        hover: { rotate: '180deg', transition: { duration: 1, type: 'spring' }, scale: 1.1 },
      },
      ref: introRef,
      children: <JadeSoftInterface />,
    },
    {
      id: 'introduction-page',
      label: 'introduction',
      path: '/interface',
      Icon: IconProduct,
      isMenu: false,
      animation: {
        initial: { rotate: '0deg', scale: 1 },
        hover: { rotate: '180deg', transition: { duration: 1, type: 'spring' }, scale: 1.1 },
      },
      ref: introRef,
      children: <Divider height={!isMobile ? 5000 : 6100} minus={!isMobile ? 5300 : 6200} />,
    },
    {
      id: 'introduction-page',
      label: 'introduction',
      path: '/interface',
      Icon: IconProduct,
      isMenu: false,
      animation: {
        initial: { rotate: '0deg', scale: 1 },
        hover: { rotate: '180deg', transition: { duration: 1, type: 'spring' }, scale: 1.1 },
      },
      ref: introRef,
      children: <ProvidersSection padding={'2% 5%'} backgroundColor={'#fff'} />,
    },
    {
      id: 'introduction-page',
      label: 'introduction',
      path: '/interface',
      Icon: IconProduct,
      isMenu: false,
      animation: {
        initial: { rotate: '0deg', scale: 1 },
        hover: { rotate: '180deg', transition: { duration: 1, type: 'spring' }, scale: 1.1 },
      },
      ref: introRef,
      children: <Telegram />,
    },

  ];

  const sectionContact = [
    {
      id: 'contact-page',
      label: 'contact',
      path: '/contact',
      Icon: IconProduct,
      isMenu: false,
      animation: {
        initial: { rotate: '0deg', scale: 1 },
        hover: { rotate: '180deg', transition: { duration: 1, type: 'spring' }, scale: 1.1 },
      },
      ref: introRef,
      children: <Subscriptions />,
    },

  ];

  const sectionAboutUs = [
    {
      id: 'about-us-page',
      label: 'about us',
      path: '/about-us',
      Icon: IconProduct,
      isMenu: false,
      animation: {
        initial: { rotate: '0deg', scale: 1 },
        hover: { rotate: '180deg', transition: { duration: 1, type: 'spring' }, scale: 1.1 },
      },
      ref: introRef,
      children: <WhoIsJadeSoft />,
    },
    {
      id: 'about-us-page',
      label: 'about us',
      path: '/about-us',
      Icon: IconProduct,
      isMenu: false,
      animation: {
        initial: { rotate: '0deg', scale: 1 },
        hover: { rotate: '180deg', transition: { duration: 1, type: 'spring' }, scale: 1.1 },
      },
      ref: introRef,
      children: <OurPartners />,
    },

  ];

  return { sections, sectionGameApi, sectionSolution, sectionWhitelabel, sectionContact, sectionAboutUs, sectionSelfService };
}
